import { apiSlice } from '../api/apiSlice'
import { RequestProps, UsersTechnology } from '../../types'
import dayjs from 'dayjs'
import CandidatesResponse from '../../types/response/CandidatesResponse'
import Candidate from '../../types/models/Candidate'
import { changeEmptyStringsToNull, changeNullsToEmptyString } from '../../utils/falsyValuesConverter'

const commonUrl = 'candidates'

export const extendedApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getCandidates: builder.query<CandidatesResponse, RequestProps>({
      query: (props: RequestProps) => ({
        url: commonUrl,
        params: props,
      }),
      transformResponse: (responseData: CandidatesResponse) => {
        return responseData
      },
      providesTags: () => [{ type: 'Candidate', id: 'LIST' }],
    }),

    getCandidateById: builder.query<Candidate, string>({
      query: (id: string) => `/${commonUrl}/${id}`,
      transformResponse: (responseData: Candidate) => {
        return changeNullsToEmptyString(responseData)
      },
      providesTags: () => [{ type: 'Candidate', id: 'LIST' }],
    }),

    createCandidate: builder.mutation({
      query: (candidate: Partial<CandidateModify>) => ({
        url: commonUrl,
        method: 'POST',
        body: changeEmptyStringsToNull(candidate),
      }),
      invalidatesTags: () => [{ type: 'Candidate', id: 'LIST' }],
    }),

    editCandidate: builder.mutation<Candidate, EditArgs>({
      query: ({ id, candidate }) => {
        let url = `/${commonUrl}/${id}`
        return {
          url: url,
          method: 'PUT',
          body: changeEmptyStringsToNull(candidate),
        }
      },
      invalidatesTags: () => [{ type: 'Candidate', id: 'LIST' }],
    }),

    deleteCandidate: builder.mutation<Candidate, string>({
      query: (id: string) => ({
        url: `/${commonUrl}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: () => [{ type: 'Candidate', id: 'LIST' }],
    }),
    updateCandidateFollowing: builder.mutation<boolean, { candidateId: string; body: { following: boolean } }>({
      query: ({ candidateId, body }) => ({
        url: `/${commonUrl}/${candidateId}/following`,
        method: 'PATCH',
        body: body,
      }),
      invalidatesTags: () => [{ type: 'Candidate', id: 'LIST' }],
    }),
  }),
})

export type CandidateModify = {
  id: string
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  localization: string
  cv: string
  repository: string
  dateOfApplication: dayjs.Dayjs
  description: string
  comment: string
  technologies: UsersTechnology[]
  version: number
}

type EditArgs = {
  id: string
  candidate: Partial<CandidateModify>
}

// Generated hooks
export const {
  useGetCandidatesQuery,
  useLazyGetCandidateByIdQuery,
  useCreateCandidateMutation,
  useDeleteCandidateMutation,
  useEditCandidateMutation,
  useGetCandidateByIdQuery,
  useUpdateCandidateFollowingMutation,
} = extendedApiSlice
